import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Button, Title } from '../../../components/UI/ComponentsUI';
import PhysicalConfirmationService from '../../../services/PhysicalConfirmationService';
import { translate, showMessageToastCustom } from '../../../utils/util';

const ReceiptContainerFinish = (props) => {
    const onSubmit = () => {
        if (!props.user.shed) {
            return showMessageToastCustom(translate('general:warning'),
                translate('validations:select-shed'),
                3000, 'mdi mdi-alert-circle-outline red-text');
        }

        props.finalizarConferencia({
            physicalConfirmationId: props.items[0]?.physicalConfirmation?.Id,
            justificationId: null,
            shed: props.user.shed,
            user: props.user.userName,
            vasilhames: props.vasilhames
        }, () => {
            props.onCancel();
        });
    }

    return (
        <div>
            <div>
                <div className="container-fluid h-65" />
                <Title label={"Finalizar Recebimento"} />
                <div className="container s12" style={{ marginTop: '30px' }}>
                    <b>MVM: {props.items[0]?.physicalConfirmation?.mvmNumber}</b>
                    <div className="row">
                        <div className="col s12 lefth" style={{ marginTop: '15px' }}>
                            <Button
                                full="true"
                                disabled={!props.items[0]?.physicalConfirmation?.mvmNumber}
                                className="col s6 btn-principal"
                                text={translate('finalize-container', 'physical-confirmation')}
                                onClick={onSubmit}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        sheds: state.configReducer.sheds,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getReceipts: (filter, callback) => {
            dispatch(PhysicalConfirmationService.getReceipts(filter, callback));
        },
        receiptByContainer: (dto, callback) => {
            dispatch(PhysicalConfirmationService.receiptByContainer(dto, callback));
        },
        finalizarConferencia: (dataFinished, callback) => {
            dispatch(PhysicalConfirmationService.finishPhysicalConfirmation(dataFinished, callback));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ReceiptContainerFinish));